import React from 'react'
import { useIntl } from 'react-intl'
import { Box, Container, Typography, withStyles } from '@material-ui/core'

import { usersStyles } from './users.styles'
import { UsersHeader, UsersStatusCounters, UsersTable } from '../../../features/users'
import { UsersContext } from '../../../features/users/contexts'

export const UsersPage = withStyles(usersStyles)(({ classes }) => {
  const { formatMessage } = useIntl()

  return (
    <UsersContext>
      <div className={classes.root}>
        <Container className={classes.container} maxWidth="lg">
          <div className={classes.titleWrapper}>
            <Typography variant="h4" color="primary" paragraph>
              {formatMessage({ id: 'pages.users.title' })}
            </Typography>
          </div>
          <Box mb={2}>
            <UsersStatusCounters />
          </Box>
          <Box mb={2}>
            <UsersHeader />
          </Box>
          <Box mb={2}>
            <UsersTable />
          </Box>
        </Container>
      </div>
    </UsersContext>
  )
})
